import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, ProgressBar, Table, Badge } from "react-bootstrap";
import CustomButton from '../../components/button';

import axios from 'axios';
import JsBarcode from 'jsbarcode';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import SearchBar from '../../components/searchbar/index'; // Adjust the import path as needed
import { TbMapSearch } from "react-icons/tb";
import './tracking.css'
const TrackShipment = ({ user }) => {
  const [shipmentId, setShipmentId] = useState('');
  const [shipmentData, setShipmentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  // Handle shipment ID input change
  const handleInputChange = (e) => {
    const value = e.target.value.trim();
    setShipmentId(value);

    if (!value) {
      // Clear the results if input is empty
      setShipmentData(null);
    }
  };

  // Search for shipment by ID
  const searchShipment = async (id) => {
    if (!id) {
      toast.error('Please enter a valid shipment ID.');
      setShipmentData(null); // Clear results on invalid input
      return;
    }

    setLoading(true);
    try {
        
      const email = user.email;
      const response = await axios.post(
        
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/track`,
        {

          id, // Send barcode in the request body
          email, // Send logged-in user's email in the request body
          
        },
        {
            headers: {
                Authorization: `Bearer ${user.token}`,
            },
        }
        
      );

      if (response.data) {
        setShipmentData(response.data);
        console.log(shipmentData);
        
      } else {
        setShipmentData(null);
        toast.error('Shipment not found.');
      }
    } catch (error) {
      console.error('Error fetching shipment details:', error);
      toast.error('Failed to fetch shipment details. Please try again.');
      setShipmentData(null); // Clear results on error
    } finally {
      setLoading(false);
    }
  };

  // Generate the barcode once shipmentData is available
  useEffect(() => {
    if (shipmentData) {
      JsBarcode('#barcode', shipmentData.shipmentId, {
        format: 'CODE128',
        width: 1.1,
        height: 40,
        displayValue: true,
      });
    }
  }, [shipmentData]);

  return (
    <Container fluid className="p-4 bg-light" style={{minHeight: '92vh'}}>
    <div className="container my-5">
      <h2 className="text-center mb-4" style={{ color: '#005A9C'}}>Track Your Shipment</h2>

      <div className="row justify-content-center mb-4">
        <div className="col-md-6">
          <SearchBar
            value={shipmentId}
            onChange={handleInputChange}
            ref={inputRef}
            placeholder="Enter Barcode..."
          />
          <CustomButton variant="primary" className={"btn mt-3 w-100 shadow-sm"}
            onClick={() => searchShipment(shipmentId)}
            disabled={loading}
          >
            <TbMapSearch/>
            <div className='ml-3'> {loading ? 'Tracking...' : 'Track'}</div>
            
          </CustomButton>
        </div>
      </div>

      {loading ? (
  <div className="text-center">
    <div className="spinner-border text-primary" role="status"></div>
    <p className="mt-3">Loading...</p>
  </div>
) : shipmentData ? (
  <div className="card p-4 shadow-sm">
    <h4 className="text-center mb-4">Shipment Details</h4>
    <br/>
    <div className="row">
      {/* Table Column */}
      <div className="col-md-6">
        <table className="table table-bordered table-striped">
          <tbody>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Shipment ID</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.shipmentId}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Sender Name</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.senderName}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Receiver Name</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.receiverName}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Phone Number</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.phoneNumber}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Address</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.address}</td>
            </tr>

            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Rider</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}> {shipmentData.rider}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Status</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{shipmentData.status}</td>
            </tr>
            <tr>
              <th className="text-center" style={{ lineHeight: '2rem' }}>Last Update</th>
              <td className="text-center" style={{ lineHeight: '2rem' }}>{new Date(shipmentData.updatedAt).toLocaleString('en-GB', { timeZone: 'Asia/Dubai' })}</td>
            </tr>
          </tbody>
        </table>
        <div className="text-center mt-4 d-none d-md-block">
          <h5>Generated Barcode</h5>
          <svg id="barcode" className="mx-auto" style={{ border: '1px solid #ddd', padding: '10px' }}></svg>
        </div>

      </div>

      {/* Timeline Column */}
      <div className="col-md-6">
        <h5 className="text-center">Tracking History</h5>
        {shipmentData.trackingHistory && (
          <div className="timeline">
            {shipmentData.trackingHistory.map((history, index) => (
              <div key={index} className="timeline-item mb-4">
                <div className="timeline-date">
                  <strong>{new Date(history.timestamp).toLocaleString('en-GB', { timeZone: 'Asia/Dubai' })}</strong>
                </div>
                <div className="timeline-content">
                  <p><strong>Status:</strong> {history.status}</p>
                  {history.newIntendedDate && (
                    <p><strong>New Intended Date:</strong> {new Date(history.newIntendedDate).toLocaleDateString('en-GB', { timeZone: 'Asia/Dubai' })}</p>
                  )}
                </div>

              </div>
            ))}
          </div>
        )}
      </div>
    </div>


  </div>
) : (
  <div className="text-center mt-5">
    <p>No result found</p>
  </div>
)}


    </div>
    </Container>
  );
};

export default TrackShipment;
